import React from "react";
import { FaUserCheck, FaHandshake, FaShieldAlt } from "react-icons/fa";
import limcaLogo from "../../assets/limca_logo2.png"; // Update path if needed

const StatsSection = () => {
  return (
    <div className="bg-white py-2 pt-4 px-4 md:px-12">
      {/* Top Statistics */}

      {/* Limca Record Section */}
      <div className="mt-6 bg-yellow-50 rounded-xl p-4 flex flex-col md:flex-row items-center justify-center text-center">
        <img
          src={limcaLogo}
          alt="Where millions found love and began their forever."
          className="h-16 mb-3 md:mb-0 md:mr-4"
        />
        <div>
          <h4 className="font-extrabold text-[#800000] tracking-wide drop-shadow-md">
            Lakhs of Happy Marriages!
          </h4>
          <p className="text-gray-700">
            The trusted choice of millions for meaningful connections and happy
            marriages.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 bg-[#fff7f0] mt-4 pt-4 gap-6 text-center border-b pb-6">
        {/* Item 1 */}
        <div className="flex flex-col items-center">
          <div className="text-green-600 mb-2">
            <FaUserCheck className="text-green-600" size={48} />
          </div>
          <h3 className="text-xl font-bold">100%</h3>
          <p className="text-gray-600">Mobile-verified profiles</p>
        </div>

        {/* Item 2 */}
        <div className="flex flex-col items-center">
          <div className="text-green-600 mb-2">
            <FaHandshake className="text-green-600" size={48} />
          </div>
          <h3 className="text-xl font-bold">Thousand +</h3>
          <p className="text-gray-600">Customers served</p>
        </div>

        {/* Item 3 */}
        <div className="flex flex-col items-center">
          <div className="text-green-600 mb-2">
            <FaShieldAlt className="text-green-600" size={48} />
          </div>
          <h3 className="text-xl font-bold"> Years</h3>
          <p className="text-gray-600">of successful matchmaking</p>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
